/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 *
 *  Centralized brand color tokens.
 *  Import from here instead of hardcoding hex values throughout the codebase.
 *  When the brand palette changes, update only this file.
 */

// ── Primary palette ──────────────────────────────────────────────────
export const BRAND_PRIMARY = '#1976d2';       // Cenozon blue – buttons, links, active states
export const BRAND_PRIMARY_DARK = '#0d47a1';  // Dark blue – hover states, emphasis
export const BRAND_PRIMARY_LIGHT = '#e3f2fd'; // Light blue – subtle backgrounds, tints

// ── Secondary / accent ───────────────────────────────────────────────
export const BRAND_SECONDARY = '#dc004e';     // Accent pink/red
export const BRAND_ACCENT = '#F7941D';        // Cenozon orange – highlights, badges

// ── Semantic colors ──────────────────────────────────────────────────
export const BRAND_ERROR = '#d32f2f';
export const BRAND_WARNING = '#ed6c02';
export const BRAND_SUCCESS = '#2e7d32';

// ── Surfaces ─────────────────────────────────────────────────────────
export const BRAND_BG_DEFAULT = '#f5f5f5';
export const BRAND_BG_PAPER = '#ffffff';

// ── Hover helpers ────────────────────────────────────────────────────
export const BRAND_PRIMARY_HOVER = '#1565c0'; // Standard MUI blue[800] for hover
